import { BULK_SEND_FINAL_STATUS_MESSAGE } from '../../constants/bulkSendManager';
import { TUserTaskFinalStatus } from '../../types/userTask';
import notification from '../../utils/notification';
import { IBulkSendTransition } from './detectBulkSendTransitions';

type TNotify = (message: string) => void;

const NOTIFY_BY_STATUS: Record<TUserTaskFinalStatus, TNotify> = {
  completed: (message) => notification.success(message, { content: message }),
  completed_with_errors: (message) => notification.error(message, { content: message }),
  failed: (message) => notification.error(message, { content: message }),
};

export const buildBulkSendStatusMessage = ({ title, status }: IBulkSendTransition): string =>
  `Bulk send "${title}" ${BULK_SEND_FINAL_STATUS_MESSAGE[status]}`;

export const notifyBulkSendTransition = (transition: IBulkSendTransition): void => {
  NOTIFY_BY_STATUS[transition.status](buildBulkSendStatusMessage(transition));
};
